export default {
  data () {
    return {
      x:100,//圆心X轴
      y:100,//圆心Y轴
      r: 36,//半径
      canvas: '',//画布
      context: '',//画笔
      curPercent:0,//当前进度，用于显示动画效果
      animationId:[],//动画ID
    }
  },
  props:{
    width:{
      type:Number,
      default: 120
    },//宽
    height:{
      type:Number,
      default: 120
    },//高
    bgColor:{//背景颜色
       type:String,
       default:'#cccccc'
    },
    color:{//圆环颜色
      type:String,
      default:'#409EFF'
    },
    textColor:{//文本颜色
      type:String,
      default:'#409EFF'
    },
    lineWidth:{//圆环宽度
      type:Number,
      default:8
    },
    percent:{//进度
      type:Number,
      default:0
    },
   
  },
  watch:{
    percent(){//当进度改变时重新绘制图形
      const me = this;
      // me.canvas.height = me.height;
      me.redraw();
    },
    width(){
      this.initParams();
      this.redraw();
    }
  },
  mounted () {
    const me = this;
    me.initParams();
    me.redraw();
  },
  methods:{
    initParams(){//初始化参数
      const me = this;
      me.canvas = me.$refs['circular_canvas'];
      me.context = me.canvas.getContext("2d");
      if(me.width){
        me.canvas.width = me.width;
      }else{
        me.width = me.canvas.width;
      }
      if(me.height){
        me.canvas.height = me.height;
      }else{
        me.height = me.canvas.height;
      }
      me.x = me.canvas.width * 0.5;
      me.y = me.canvas.height * 0.5;
      me.r = parseInt(me.x < me.y ? me.x * 0.75 : me.y * 0.75);
    },
    draw(){
      const me = this;
      me.writeBg();
      me.writeProgress();
      me.writeText();
    },
    redraw(){//重新绘制图形
      const me = this;
      console.log(me.percent);
      if(me.percent <= 0){
          me.writeBg();
          me.writeText();
      }
      if(me.curPercent < me.percent){
        me.curPercent = me.curPercent + 0.5;
        me.context.clearRect(0,0,me.canvas.width, me.canvas.height);
        me.draw();
        me.animationId.push(requestAnimationFrame(me.redraw));
      }else{
        for(let i in me.animationId){
          cancelAnimationFrame(me.animationId[i]);
        }
      }
    },
    writeBg(){//绘制背景
      const me = this;
      me.context.save();
      me.context.strokeStyle = me.bgColor;
      me.context.lineWidth = me.lineWidth > 7 ? parseInt(me.lineWidth * 0.8) : me.lineWidth;
      me.context.beginPath();
      me.context.arc(me.x, me.y, me.r, 0, Math.PI * 2, false);
      me.context.stroke();
      me.context.closePath();
    },
    writeProgress(){//绘制进度圆环
      const me = this;
      let p = me.curPercent * 2 / 100;
      me.context.save();
      me.context.strokeStyle = me.color;
      me.context.lineWidth = me.lineWidth;
      me.context.lineCap = 'round';
      me.context.beginPath();
      me.context.arc(me.x, me.y, me.r, -Math.PI*0.5, -Math.PI*0.5 + Math.PI * p , false);
      me.context.stroke();
      me.context.restore();
    },
    writeText(){//绘制文本
      const me = this;
      let pst = (me.percent+"").length < 3 ? 10 : 20;
      me.context.save();
      me.context.font = "16px Arial";
      me.context.fillStyle = me.textColor; //字体颜色
      me.context.fillText(me.percent+'%', me.x - pst , me.y + 6); //绘制实心
      me.context.restore();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/base/view/cmps/charts/circular/src/circular.js